import {cx} from "@emotion/css";
import {ReactComponent as SvgCopy} from "assets/svg/copy.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmCopyIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgCopy id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
